import React from "react"
import { Col, Row } from "reactstrap"
import LeftCard from "./LeftCard"
import RightCard from "./RightCard"

const RightSide = props => {
  return (
    <Col sm="12">
      <Row>
        <LeftCard {...props} />
        <RightCard {...props} />
      </Row>
    </Col>
  )
}

export default RightSide
